import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AccessTime as AttendanceIcon,
  ShoppingCart as StockInIcon,
  ShoppingCartCheckout as StockOutIcon,
  LocalShipping as TransportIcon,
  Business as VendorIcon
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
const Dashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const categories = [
    {
      name: 'Attendance',
      icon: <AttendanceIcon className="w-8 h-8 text-white" />,
      bgColor: 'bg-blue-600',
      href: '/attendance'
    },
    {
      name: 'Stock In',
      icon: <StockInIcon className="w-8 h-8 text-white" />,
      bgColor: 'bg-green-500',
      href: '/stock-in'
    },
    {
      name: 'Stock Out',
      icon: <StockOutIcon className="w-8 h-8 text-white" />,
      bgColor: 'bg-orange-500',
      href: '/stock-out'
    },
    {
      name: 'Transport',
      icon: <TransportIcon className="w-8 h-8 text-white" />,
      bgColor: 'bg-teal-500',
      href: '/transport'
    },
    {
      name: 'Vendor Overview',
      icon: <VendorIcon className="w-8 h-8 text-white" />,
      bgColor: 'bg-blue-500',
      href: '/vendors'
    }
  ];

  const handleCategoryClick = (href) => {
    navigate(href);
  };

  const recentActivities = [
    {
      title: 'Guindy Site - VVN Traders',
      description: 'Bricks Received: A new stock of bricks has been received from VVN Traders at the Guindy site and recorded into inventory.'
    },
    {
      title: 'SHS Vendor - Payment Update',
      description: 'Pending Amount Cleared: The pending payment from the SHS vendor has been successfully received, resolving outstanding dues.'
    },
    {
      title: 'MRR - Stock Request for Payment',
      description: 'Material Receipt Report (MRR): A stock request has been raised through MRR and submitted for payment processing.'
    }
  ];

  return (
    <div className="bg-gray-50">
      <div className="flex">
        {/* Left Section */}
        <div className="flex-1 mr-6">
          {/* Welcome Banner */}
          <div className="rounded-lg p-6 mb-6 relative" style={{ backgroundColor: '#009688' }}>
            <div className="flex justify-between items-start">
              <div>
                <h1 className="text-3xl text-white mb-2">Welcome, {user?.username}</h1>
              
              </div>
              
            </div>
          </div>

          {/* Category Section */}
          <div className="mt-6 pb-10 p-6 border-l border-gray-200 category-card">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Category</h2>
            <div className="space-y-6">
              {/* First row - 3 items */}
              <div className="grid grid-cols-3 gap-6" style={{marginTop: '60px'}}>
                {categories.slice(0, 3).map((category, index) => (
                  <div 
                    key={index} 
                    className="text-center cursor-pointer group"
                    onClick={() => handleCategoryClick(category.href)}
                  >
                    <div className={`w-16 h-16 ${category.bgColor} rounded-full flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-200`}>
                      {category.icon}
                    </div>
                    <p className="text-md font-medium text-gray-700">{category.name}</p>
                  </div>
                ))}
              </div>
              {/* Second row - 2 items */}
              <div className="grid grid-cols-3 gap-6 mt-10" style={{marginTop: '90px'}}>
          
                {categories.slice(3, 5).map((category, index) => (
                  <div 
                    key={index + 3} 
                    className="text-center cursor-pointer group"
                    onClick={() => handleCategoryClick(category.href)}
                  >
                    <div className={`w-16 h-16 ${category.bgColor} rounded-full flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-200`}>
                      {category.icon}
                    </div>
                    <p className="text-md font-medium text-gray-700">{category.name}</p>
                  </div>
                ))}
                <div></div> {/* Empty div for spacing */}
              </div>
            </div>
          </div>
        </div>

        {/* Right Section */}
        {/* <div className="w-80 bg-white p-6 border-l border-gray-200 category-card">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Recently Activity</h2>
          <div className="space-y-4">
            {recentActivities.map((activity, index) => (
              <div key={index} className="border-b border-gray-200 pb-4 last:border-b-0">
                <h3 className="font-bold text-gray-900 mb-2">{activity.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{activity.description}</p>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Dashboard;
